<template>
  <div id="app">
    <!-- Loader starts-->
    <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader-index">
        <span></span>
      </div>
    </div>
    <!-- Loader ends-->

    <!--<Main/>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      show: true
    }
  },
  mounted() {
    this.timeOut();
    const removeSyncfusionModal = () => {
      const modals = document.querySelectorAll('div[style*="z-index: 99999"]');
      modals.forEach(el => el.remove());
    };

    setTimeout(removeSyncfusionModal, 100);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        const modal = document.querySelector('div[style*="z-index: 99999"]');
        if (modal) modal.remove();
      });
    });
    observer.observe(document.body, {childList: true, subtree: true});
  },
  methods: {
    timeOut() {
      var self = this;
      setTimeout(function () {
        self.show = false;
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/vendors/bootstrap-vue/index";
// kanban css
@import '../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-layouts/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css';
@import '../node_modules/@syncfusion/ej2-vue-kanban/styles/bootstrap5.css';

.loader-wrapper.loderhide {
  display: none;
}

div[style*="z-index: 99999"],
div[style*="z-index:99999"] {
  display: none !important;
}

div[aria-label*="Syncfusion"] {
  display: none !important;
}
</style>
